var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { loginApi } from "apis/eduidLogin";
import { CommonToU } from "components/Common/CommonToU";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import loginSlice from "slices/Login";
export function TermsOfUse() {
    const dispatch = useAppDispatch();
    const availableTouVersions = useAppSelector((state) => state.login.tou.available_versions);
    // version is the version of the ToU the backend requests we ask the user to accept
    const version = useAppSelector((state) => state.login.tou.version);
    const loginRef = useAppSelector((state) => state.login.ref);
    const [fetchAbort] = loginApi.useLazyFetchAbortQuery();
    const [fetchToU] = loginApi.useLazyFetchToUQuery();
    useEffect(() => {
        if (!version && loginRef) {
            // Tell the backend what ToU versions are available in this bundle
            fetchToU({ ref: loginRef, versions: availableTouVersions });
        }
    }, [availableTouVersions, fetchToU, loginRef, version]);
    function handleAccept() {
        return __awaiter(this, void 0, void 0, function* () {
            if (version && loginRef) {
                // Tell the backend which ToU version the user accepted
                const response = yield fetchToU({ ref: loginRef, user_accepts: version });
                if (response.isSuccess) {
                    if (response.data.payload.finished) {
                        dispatch(loginSlice.actions.callLoginNext());
                    }
                }
            }
        });
    }
    function handleCancel() {
        if (loginRef) {
            fetchAbort({ ref: loginRef });
        }
    }
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: _jsx(FormattedMessage, { id: "termsOfUse.heading", defaultMessage: "Log in: Terms of use", description: "Terms of use (h2 heading)" }) }), _jsx("div", { className: "lead", children: _jsx("p", { children: _jsx(FormattedMessage, { id: "termsOfUse.banner", defaultMessage: "We need an updated acceptance from you of the eduID terms of use.", description: "Terms of use (banner text)" }) }) }), version && _jsx(CommonToU, { version: version, handleAccept: handleAccept, handleCancel: handleCancel })] }));
}
